const bump = (bucket, field) => {
    bucket[field] = (bucket[field] || 0) + 1;
    bucket.total += 1;
};

export const groupRows = (rows, keyOf, seed, fieldOf) => {
    const map = new Map();

    rows.forEach((row) => {
        const key = keyOf(row);
        if (key === "" || key === undefined || key === null) return;
        if (!map.has(key)) map.set(key, seed(row));

        const field = fieldOf(row);
        if (field) bump(map.get(key), field);
    });

    return Array.from(map.values());
};

export const qaSeed = (extra) => ({
    valid: 0,
    invalid: 0,
    "not-checked": 0,
    total: 0,
    ...extra,
});

export const highlightSeed = (extra) => ({
    "has-hl": 0,
    "no-hl": 0,
    "not-checked": 0,
    total: 0,
    ...extra,
});

export const audioSeed = (extra) => ({
    "has audio": 0,
    "no audio": 0,
    total: 0,
    ...extra,
});

export const statusTally = (rows, fieldOf, labels) => {
    if (!rows.length) return [];

    const counts = Object.fromEntries(labels.map((label) => [label, 0]));

    rows.forEach((row) => {
        const field = fieldOf(row);
        if (counts[field] !== undefined) counts[field] += 1;
    });

    return labels.map((status) => ({ status, value: counts[status] }));
};
